import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import { Provider } from 'react-redux';
import App from './App';
// import reportWebVitals from './reportWebVitals';

import data from './assets/data/data';

import store from './store/store';
const action = (type, payload) => store.dispatch({type, payload})

action('UPDATE_LINK', '/'+ window.location.pathname.split('/')[1]);
action('SET_DATA', data);


function render() {
	ReactDOM.render(
		<React.StrictMode>
			<Provider store={store}>
				<BrowserRouter>
					<App action={action} store={store}/>
				</BrowserRouter>
			</Provider>
		</React.StrictMode>,
		document.getElementById('root')
	);
}
render()
store.subscribe(render)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
